import deDE from './de-DE';

const locales = {
  deDE
}

export default locales;
